import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Layout } from '../components/Layout';
import { api } from '../services/api';
import { toast } from 'sonner';
import { Lock } from 'lucide-react';

export const ChangePasswordPage = () => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword.length < 6) {
      toast.error('Le mot de passe doit contenir au moins 6 caractères');
      return;
    }
    if (newPassword !== confirmPassword) {
      toast.error('Les mots de passe ne correspondent pas');
      return;
    }

    setLoading(true);
    try {
      await api.post('/auth/change-password', { new_password: newPassword });
      // Update local user data
      const userData = JSON.parse(sessionStorage.getItem('eva_user') || '{}');
      userData.must_change_password = false;
      sessionStorage.setItem('eva_user', JSON.stringify(userData));
      toast.success('Mot de passe modifié avec succès');
      navigate('/dashboard');
    } catch (error) {
      toast.error("Erreur lors du changement de mot de passe");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white/5 flex items-center justify-center p-4" data-testid="change-password-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-white tracking-tight">Eva</h1>
          <p className="text-xs text-slate-400 mt-1">by ASAP Technologies</p>
        </div>

        <div className="bg-[#0B132B] rounded-lg border border-white/10 p-8">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 bg-amber-500/15 rounded-lg flex items-center justify-center">
              <Lock size={20} className="text-[#F59E0B]" />
            </div>
            <div>
              <h2 className="text-lg font-semibold text-white">Changement de mot de passe</h2>
              <p className="text-sm text-slate-400">Veuillez définir votre nouveau mot de passe</p>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="eva-label">Nouveau mot de passe</label>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className="eva-input"
                placeholder="Minimum 6 caractères"
                required
                data-testid="new-password-input"
              />
            </div>
            <div>
              <label className="eva-label">Confirmer le mot de passe</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="eva-input"
                placeholder="Confirmez votre mot de passe"
                required
                data-testid="confirm-password-input"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="eva-btn-primary w-full"
              data-testid="change-password-submit"
            >
              {loading ? 'Modification...' : 'Valider'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
